export const circularProgress = {
    outerRadius: .8,
    innerRadius: .6,
    progress: {
        style: {
            fillOpacity: 1
        }
    },
    track: {
        style: {
            fillOpacity: .2
        }
    },
    tickMask: {
        visible: !1,
        angle: 3,
        offsetAngle: 0,
        forceAlign: !0
    }
};
//# sourceMappingURL=circular-progress.js.map
